import { useEffect, useState } from 'react';

import { LookupAutocompleteView } from '@/shared/ui/molecules/LookupAutocomplete';

import { useClassModuleSearchDropdown } from '../../../hooks/useClassModuleSearchDropdown';
import type { LookupAutocompleteProps } from './CompanyAutocomplete';

export interface ClassModuleAutocompleteProps extends LookupAutocompleteProps {
  /** Curso selecionado, para escopar a busca de módulos (`CourseId`), ou `null`. */
  readonly courseId?: number | null;
}

/** Autocomplete de módulo de aula (lookup `shared/class-modules`), opcionalmente escopado por curso. */
export function ClassModuleAutocomplete({
  value,
  selectedLabel: selectedLabelProp = '',
  onChange,
  label,
  placeholder,
  hasError,
  courseId = null,
}: ClassModuleAutocompleteProps) {
  const [search, setSearch] = useState('');
  const [inputText, setInputText] = useState(selectedLabelProp);
  const { options, isQuerySuccess } = useClassModuleSearchDropdown(search, courseId);

  useEffect(() => {
    setInputText(selectedLabelProp);
  }, [selectedLabelProp]);

  return (
    <LookupAutocompleteView
      label={label}
      placeholder={placeholder}
      value={value !== null ? String(value) : ''}
      selectedLabel={inputText}
      options={options}
      isQuerySuccess={isQuerySuccess}
      search={search}
      hasError={hasError ?? false}
      onSearchChange={setSearch}
      onSelect={(id, itemLabel) => {
        onChange(id ? Number(id) : null, itemLabel);
        setInputText(itemLabel);
        setSearch('');
      }}
      onClear={() => {
        onChange(null, '');
        setInputText('');
        setSearch('');
      }}
    />
  );
}
